// KHUYẾN NGHỊ thay cho RÀNG BUỘC của tham số SỐ (05/10/2026, người dùng: "đừng đặt số nhóm hay bình luận hay gì đó TỐI ĐA — chỉ đưa ra lời
// khuyên chứ không ép"). Tệp NHẸ (không import gì) — dùng chung máy chủ (chuanHoaSoDo, kiemKeHoach) và trang web (nhãn + cảnh báo mềm cạnh ô số).
//
// · min/max của tham số trong khối (src/shared/*-khoi.ts, KhoiThamSo) = KHOẢNG KHUYÊN DÙNG: ngoài khoảng vẫn lưu / dịch / chạy được, trang chỉ
//   hiện lời khuyên ("Khuyên 1–3 nhóm/lượt để tránh bị Facebook hạn chế — bạn đặt 8").
// · Chỉ CHẶN ngoài TRẦN KỸ THUẬT (khoangKyThuat) — giá trị vô nghĩa hoặc làm treo bot:
//     - số lượng mục mỗi lượt (so_*): 1–100 (0 khi khuyến nghị bắt đầu từ 0 — vd "0 = không thích"). Một lượt chạy bị Boss cắt sau tối đa 240 phút
//       (HAN_LENH_PHUT.toiDa ở so-do.ts); mỗi mục mất 30 giây tới vài phút (cả chờ duyệt) → trên 100 mục là chắc chắn bị cắt giữa chừng.
//     - giây: 1–3600 (một lần nghỉ/xem/đọc tối đa 1 giờ — hơn nữa lượt chạy sẽ bị cắt vì quá hạn).
//     - ngày: 0–365.   - phần trăm: khuyến nghị dưới – 100.
//   Trần RIÊNG theo giới hạn THẬT của runner / khối hiện hành (TRAN_RIENG) — giá trị vượt đó bot sẽ lặng lẽ kẹp lại, nên chặn ngay khi lưu và
//   nói rõ vì sao. Khối định nghĩa max LỚN hơn trần chung thì theo khối.
// Hạn mức mỗi ngày/giờ (Cài đặt bot, giới hạn kịch bản) KHÔNG thuộc tệp này — vẫn áp như cũ.

export interface ThamSoSo { ten: string; kieu: "chuoi" | "so"; min?: number; max?: number }
export type LoaiSo = "dem" | "giay" | "ngay" | "phan_tram";

/** Loại tham số số theo TÊN (quy ước tên của mọi khối hiện có). */
export function loaiSo(ten: string): LoaiSo {
  if (/^ti_le/.test(ten)) return "phan_tram";
  if (/giay/.test(ten)) return "giay";
  if (/ngay$/.test(ten)) return "ngay";
  return "dem";
}

export const TRAN_KY_THUAT: Record<LoaiSo, number> = { dem: 100, giay: 3600, ngay: 365, phan_tram: 100 };
const LY_DO_TRAN: Record<LoaiSo, string> = {
  dem: "một lượt chạy bị Boss cắt sau tối đa 240 phút — nhiều mục hơn sẽ không kịp làm",
  giay: "một lần quá 1 giờ thì lượt chạy bị cắt vì quá hạn",
  ngay: "tối đa một năm",
  phan_tram: "phần trăm không vượt 100",
};
// Giới hạn THẬT của runner / khối hiện hành (đo trong mã, 05/10/2026). Đổi runner / khối thì sửa ở đây.
export const TRAN_RIENG: Record<string, { max: number; lyDo: string }> = {
  // 07/10/2026: người dùng lướt 5 phút ("Lướt bảng tin 5 phút") — trần 270 s (bước lướt 300 s) nâng lên 1800 s (30 phút): runner runLuot lấy ngân sách của bước = max(timeout bundle, giây yêu cầu + 30 s).
  // Bundle lướt > 270 s khai can_plugin PLUGIN_CAN_LUOT_DAI (plugin cũ kẹp lặng lẽ ở 270 s).
  thoi_gian_giay: { max: 1800, lyDo: "lướt một lần tối đa 30 phút (runner runLuot) — lướt lâu hơn nên chia thành nhiều bước lướt xen nghỉ" },
  so_bai_xem: { max: 50, lyDo: "bot lướt gom tối đa 50 bài một lần (runner runLuot)" },
  // 05/10/2026: bỏ trần cứng 3 (người dùng: không ép tối đa) — khuyên 0–3 vẫn hiện; giới hạn thật = số bài bot lướt gom tối đa một lần.
  so_thich: { max: 50, lyDo: "không thích nhiều hơn số bài bot lướt gom được một lần (tối đa 50, runner runLuot)" },
  so_lan_xem_them: { max: 20, lyDo: "bot bấm “Xem thêm” tối đa 20 lần mỗi bài (runner moRong)" },
  // 06/10/2026 "Chờ giữa các lần": tối đa 24 giờ (cho-giua-lan.ts TRAN_CHO_GIAY); 0 được phép (không chờ). Lời khuyên theo loại việc ở kiemKhoangCho.
  cho_tu_giay: { max: 86400, lyDo: "chờ giữa hai lần tối đa 24 giờ" },
  cho_den_giay: { max: 86400, lyDo: "chờ giữa hai lần tối đa 24 giờ" },
  // (08/10/2026, đợt B) lướt theo phút: một lần tối đa 30 phút (như thoi_gian_giay 1800 s)
  tu_phut: { max: 30, lyDo: "lướt một lần tối đa 30 phút — lâu hơn nên chia thành nhiều bước lướt xen nghỉ" },
  den_phut: { max: 30, lyDo: "lướt một lần tối đa 30 phút — lâu hơn nên chia thành nhiều bước lướt xen nghỉ" },
  ti_le_thich: { max: 30, lyDo: "bản chạy kẹp tỉ lệ thích ở 30% (ti-le-thich.ts — đổi là đổi hash mọi kịch bản có lướt)" },
};

export interface KhoangKyThuat { min: number; max: number; lyDoMax: string }
/** Khoảng giá trị bot CHẠY ĐƯỢC (ngoài khoảng → chặn lưu). Luôn chứa trọn khoảng khuyến nghị của khối. */
export function khoangKyThuat(d: Pick<ThamSoSo, "ten" | "min" | "max">): KhoangKyThuat {
  const loai = loaiSo(d.ten);
  const min = loai === "phan_tram" ? (d.min ?? 0) : Math.min(d.min ?? 0, 1);
  const rieng = TRAN_RIENG[d.ten];
  const tran = rieng?.max ?? TRAN_KY_THUAT[loai];
  const max = Math.max(tran, d.max ?? 0);
  return { min, max, lyDoMax: max === tran ? (rieng?.lyDo ?? LY_DO_TRAN[loai]) : "giới hạn của thao tác" };
}

/** Lỗi CHẶN của một giá trị đã là số nguyên (null = chạy được). Câu ngắn "tối thiểu N" / "tối đa N (lý do)" để ghép sau nhãn ô. */
export function loiNgoaiTran(d: Pick<ThamSoSo, "ten" | "min" | "max">, n: number, tranGiayNghi?: number): string | null {
  const k = khoangKyThuat(d);
  // (08/10/2026, đợt A) ô Nghỉ là CHỖ CẮT của sơ đồ nhiều đường: Boss giữ đồng hồ (bot rảnh thật, không có lượt chạy nào bị cắt vì quá hạn) → trần riêng (6 giờ).
  if (tranGiayNghi !== undefined && loaiSo(d.ten) === "giay" && tranGiayNghi > k.max) { k.max = tranGiayNghi; k.lyDoMax = "ô Nghỉ do Boss giữ nhịp tối đa 6 giờ"; }
  if (n < k.min) return `tối thiểu ${k.min}`;
  if (n > k.max || !Number.isFinite(n)) return `tối đa ${k.max} (${k.lyDoMax})`;
  return null;
}

/** Có khoảng khuyên dùng hẹp hơn khoảng chạy được không (có thì nhãn ghi "khuyên", ô hiện lời khuyên khi vượt). */
export function coKhuyenNghi(d: ThamSoSo): boolean {
  if (d.kieu !== "so" || (d.min === undefined && d.max === undefined)) return false;
  const k = khoangKyThuat(d);
  return (d.min ?? k.min) > k.min || (d.max ?? k.max) < k.max;
}

/** Nhãn khoảng sau tên ô số: " (khuyên 1–3)" khi là lời khuyên; " (0–30)" khi khoảng đó chính là giới hạn chạy được; "" khi không có khoảng. */
export function nhanKhoang(d: ThamSoSo): string {
  if (d.kieu !== "so" || d.min === undefined || d.max === undefined) return "";
  return coKhuyenNghi(d) ? ` (khuyên ${d.min}–${d.max})` : ` (${d.min}–${d.max})`;
}

const DON_VI: Record<string, string> = {
  so_nhom: "nhóm/lượt", so_bai: "bài/lượt", so_bai_xem: "bài/lượt", so_bai_doc: "bài/lượt", so_thich: "bài/lượt", so_video: "video/lượt",
  so_tra_loi: "câu trả lời/lượt", so_cau: "câu trả lời/lượt", so_lan_xem_them: "lần mỗi bài",
};
const LUU_Y: Record<string, string> = {
  so_nhom: "Hạn mức “số nhóm tự tham gia mỗi ngày” trong Cài đặt của bot vẫn áp dụng.",
};
function donVi(ten: string): string {
  const loai = loaiSo(ten);
  return loai === "giay" ? "giây" : loai === "ngay" ? "ngày" : loai === "phan_tram" ? "%" : DON_VI[ten] ?? "";
}

/** Lời khuyên (KHÔNG chặn) khi giá trị là số nguyên chạy được nhưng nằm ngoài khoảng khuyên dùng; null = trong khoảng / không phải số / bị chặn. */
export function canhBaoKhuyenNghi(d: ThamSoSo, giaTri: string | number, mang?: string): string | null {
  if (!coKhuyenNghi(d)) return null;
  const s = String(giaTri).trim();
  if (!/^-?\d+$/.test(s)) return null;
  const n = Number(s);
  if (loiNgoaiTran(d, n) !== null) return null; // bị chặn — ô báo lỗi, không khuyên
  const k = khoangKyThuat(d);
  const a = d.min ?? k.min, b = d.max ?? k.max;
  if (n >= a && n <= b) return null;
  const loai = loaiSo(d.ten);
  const noi = mang?.trim() || "mạng xã hội";
  const tren = n > b;
  const lyDo = loai === "giay"
    ? (tren ? "(lâu quá làm lượt chạy kéo dài, dễ bị cắt vì quá hạn)" : `(ngắn quá trông giống máy, dễ bị ${noi} hạn chế)`)
    : loai === "ngay" ? (tren ? "(giãn cách dài thì ít nhóm để đăng)" : "")
    : loai === "phan_tram" ? (tren ? `để tránh bị ${noi} hạn chế` : "")
    : tren ? `để tránh bị ${noi} hạn chế` : "(ít quá trông không giống người thật)";
  const dv = donVi(d.ten);
  const khoang = loai === "phan_tram" ? `${a}–${b}%` : `${a}–${b}${dv ? ` ${dv}` : ""}`;
  return `Khuyên ${khoang}${lyDo ? ` ${lyDo}` : ""} — bạn đặt ${n}${loai === "phan_tram" ? "%" : ""}.${LUU_Y[d.ten] && tren ? ` ${LUU_Y[d.ten]}` : ""}`;
}
